import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import classNames from 'classnames';

import { fetchPage } from 'services/api';
import { page as pageAction } from 'actions';
import { byIdShape } from 'utils/propTypes';

import PageHeader from 'AppComponents/PageHeader';

import '../../components/AverageRating/styles.scss';


class Page extends Component {

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    pageAction: PropTypes.func.isRequired,
    pages: byIdShape.isRequired,
    slug: PropTypes.string.isRequired,
  };

  static defaultProps = {
    children: null,
    className: null,
  };

  componentDidMount() {
    const page = this.props.pages[this.props.slug];
    if (!page.loaded) {
      fetchPage(this.props.slug).then(({ response, error }) => {
        if (error) {
          console.log(error);
        } else {
          this.props.pageAction(response);
        }
      });
    }
  }

  render() {
    const page = this.props.pages[this.props.slug];

    return (
      <div className={classNames('container', this.props.className)}>

        <Helmet
          title={page.title}
          meta={[
            { name: 'description', content: page.description || '' },
          ]}
        />

        <PageHeader title={page.title} />

        { page.body === undefined ?
          <div className='body'><p>Loading&hellip;</p></div>
        :
          <div
            className='body'
            dangerouslySetInnerHTML={{ __html: page.body || '' }} // eslint-disable-line react/no-danger, max-len
          />
        }

        { this.props.children }

      </div>
    );
  }
}

const mapStateToProps = state => ({
  pages: state.pages.bySlug,
});

export default connect(
  mapStateToProps, {
    pageAction,
  },
)(Page);



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Page/index.jsx